import { QUERY_KEYS } from 'api/query-keys';
import { sharedWorkforceService } from 'api/services';
import { useInfiniteQuery } from 'react-query';

export const useGetWorkforce = (searchFilter?: string) => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.workforceList(searchFilter),
    queryFn: async ({ pageParam = 0 }) =>
      await sharedWorkforceService.getEmployees({
        pageParam,
        labourEngagementStates: ['approved', 'pending', 'rejected'],
        searchFilter,
      }),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
    keepPreviousData: true,
  });
};
